import { Box, Typography } from '@mui/material'
import { useGetCriteriaLevelColor } from 'app/hooks/useAnalyzer'
import React, { useState } from 'react'
import Chart from 'react-apexcharts'

const CriteriaRadialChart = ({ title, percent, level }) => {
    const { format } = useGetCriteriaLevelColor()

    const [state] = useState({
        series: [percent],
        options: {
            chart: {
                type: 'radialBar',
                sparkline: { enabled: true }, // remove padding/margins
            },
            colors: [format(level)], // red bar
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    hollow: {
                        margin: 0, // remove hollow margin
                        size: '60%',
                    },
                    track: {
                        background: '#36434E', // gray background
                        margin: 0, // remove track margin
                    },
                    dataLabels: {
                        name: { show: false },
                        value: {
                            offsetY: 1,
                            fontSize: '22px',
                            color: undefined,
                            formatter: function (val) {
                                const n = parseFloat(val)
                                if (isNaN(n)) return '--'
                                return n.toFixed(2) + '%'
                            },
                        },
                    },
                },
            },
            labels: ['Average Results'],
        },
    })

    return (
        <Box>
            <Typography align="center" variant="h6" fontSize={12}>
                {title}
            </Typography>
            <Chart
                options={state.options}
                series={state.series}
                type="radialBar"
            />
        </Box>
    )
}

export default CriteriaRadialChart
